
import { defineComponent } from 'vue'

interface SortChoice {
  name: string
  label: string
  icon: string
}

export default defineComponent({
  name: 'IssueSort',

  props: {
    selectedSortFilter: {
      type: String,
      default: ''
    },
    showSeenOptions: {
      type: Boolean,
      default: true
    },
    popUpDirection: {
      type: String,
      default: 'right'
    }
  },

  emits: ['updateSortFilter', 'reset'],

  computed: {
    modelValue: {
      get(): string {
        return this.selectedSortFilter
      },
      set(value: string) {
        this.$emit('updateSortFilter', value)
      }
    },

    sortFilters(): Record<string, SortChoice> {
      const frequencyOpts = {
        'most-frequent': { label: 'Most frequent', icon: 'most-frequent', name: 'most-frequent' },
        'least-frequent': {
          label: 'Least frequent',
          icon: 'least-frequent',
          name: 'least-frequent'
        }
      }

      const seenOpts = {
        'first-seen': { label: 'First seen', icon: 'first-seen', name: 'first-seen' },
        'last-seen': { label: 'Last seen', icon: 'last-seen', name: 'last-seen' }
      }

      return this.showSeenOptions ? { ...frequencyOpts, ...seenOpts } : frequencyOpts
    },

    sortApplied(): boolean {
      return Boolean(this.modelValue)
    },

    filterLabel(): string {
      const filterItem = this.sortFilters[this.modelValue]
      if (!filterItem) {
        throw new Error(`Filter name not recognized: ${this.modelValue}`)
      }
      return filterItem.label
    },

    filterIcon(): string {
      const filterItem = this.sortFilters[this.modelValue]
      if (!filterItem) {
        throw new Error(`Filter name not recognized: ${this.modelValue}`)
      }
      return filterItem.icon
    }
  }
})
